import img from "../media/undraw_interview_yz52 (1).svg"
import Footer from "../components/footer";
import "../css/screening.css"
import Navbar from "../components/nav";
import Swal from "sweetalert2";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import logo1 from "../media/whiteFav.png";
import useStore from "../store/zustandstore";
import { db } from "../firebase/firebase";
import { useEffect } from "react";
import { Icon } from "@iconify/react";
import usefbStore from "../store/firebasestore";
import { doc,updateDoc,getDocs,collection } from "firebase/firestore";

function Privacy(){

    const navigate = useNavigate()
    const userID = usefbStore((s)=>s.userID)
    const setScreenCount =usefbStore((s)=>s.setScreenCount)
    const screenCount = usefbStore((s)=>s.screenCount)
     const closeFonMenu = useStore((s)=> s.closeFonMenu)
  const fonMenuDrawer = useStore((s)=> s.fonMenuDrawer)
    const hideScreenLoader= useStore((s)=>s.hideScreenLoader)
    useEffect(()=>{
     hideScreenLoader()      
    },[userID])
 
     const cnclFon = () =>{
    closeFonMenu();
  }

   const toAuth=()=>{

      navigate("/auth")
    }
  
   return (

    <section className="preScreen">
             <Helmet>
         <title>Privacy Policy | Solara</title>
  <meta
    name="description"
    content="Learn how Solara collects, uses, and protects information when you use our platform."
  />  
             </Helmet>
          <div className={`fonMenu ${fonMenuDrawer ? "fonMenuActive" : ""}`} >
        <img src={logo1} alt="" />
        <div className="sideMenuPlacer">
          <div className="fonMenuX" onClick={cnclFon}>
                
                <Icon className="faIcon" icon="solar:alt-arrow-right-linear" />
          </div>
         <div className="fonMenuLinks">

             <a href="/jobs">Job Opportunities</a>
             <a href="/dashboard">AI Tasks</a>
             <a href="/referral-program">Referral Program</a>
             <a href="/about">About Us</a>
            <button onClick={()=>toAuth()}>Get Started</button>
          </div>
          
        </div>
      </div>
        <div className="navContWhite navContWhiteLg">
                    <Navbar />
        </div>
        <div className="preScrenCont">
       <div className="preScreenImg">
             <h2>Privacy Policy</h2>
        </div>
       
        <div className="preScreenCont">
 <p>Solara, the home of innovative opportunities. Our Terms of Service (ToS) govern your access to and use of
our website located at <a href="/terms-of-service"> ToS page</a>.
By using the Services, you agree to the collection and use of information in accordance with this Privacy Policy.</p>
 
<h3><span>1.</span> Information We Collect</h3>
<p>
We may collect the following types of information:</p>
<p>Personal Information</p>
<ul>
    <li>Full name</li>
    <li>Email address</li>
    <li>Account login credentials</li>
</ul>
<p>Usage Data</p>
<ul>
    <li>IP address</li>
    <li>Browser type and device information</li>
    <li>Pages visited and time spent on site</li>
    <li>Interaction data (clicks, action, navigation patterns)</li>
</ul>
<p>Transaction & Work Data</p>
<ul>
    <li>Task submissions and performance data</li>
    <li>Payment-related information (processed via third-party providers)</li>
    
</ul>
<h3><span>2. </span>How We Use Your Information</h3>
<p>We use your information to provide, maintain, and improve our services, to process transactions and payments, to communicate with you about your account or tasks, to screen for potential risk or fraud, and to comply with legal obligations.</p>

<h3><span>3. </span> Sharing of Information</h3>
<p>
We do not sell your personal data. However, we may share information with service providers for purposes such as hosting, analytics, and payment processing. Limited information may be shared with other users where necessary for job or task collaboration. We may also disclose information to legal authorities when required by law or to protect rights and safety.
</p>

<h3><span>4. </span>Data Security</h3>
<p>
We implement reasonable technical and organizational measures to protect your data. However, no system is completely secure, and we cannot guarantee absolute security.</p>

<h3><span>5. </span>Data Retention</h3>
<p>We retain your information only as long as necessary to provide our services, comply with legal obligations, resolve disputes, and enforce our agreements.</p>
<h3><span>6. </span>Your Rights</h3>
<p>Depending on your jurisdiction, you may have the right to access your personal data, request correction of inaccurate data, request deletion of your data, or object to or restrict certain processing activities. To exercise these rights, please contact us using the details provided below.</p>
<h3><span>7. </span>Cookies and Tracking Technologies</h3>
<p>We may use cookies and similar technologies to improve user experience and analyze traffic and usage patterns. You can control cookies through your browser settings.</p>
<p>If you have questions about this Privacy Policy or your data, please contact us at admin@solarajobs.com.

By using Solara, you acknowledge that you have read and understood this Privacy Policy.</p>
        </div>

        </div>
 

      <Footer/>
        

    </section>
   )
}

export default Privacy;